export default __webpack_public_path__ + "img/bg404.jpg?a53a";